<script>
	import { onMount, onDestroy } from "svelte";
	import * as L from "leaflet";
	const icon = '/images/diamond-plane-teal.png';
	const iconDeleted = '/images/diamond-plane-thick-white.png';

	export let info;
	export let layer;

	let marker;
	let line

	const lastInfo = {}

	$: updateMarker(info)

	onMount(() => {
		updateMarker(info);
	});

	onDestroy(() => {
		if (marker) marker.removeFrom(layer)
		if (line) line.removeFrom(layer)
	});

	function updateMarker(info) {
		let markerInfo = info

		if (Array.isArray(info)) {
			markerInfo = info[info.length - 1]
		}

		if (markerInfo.type === 'RADAR_TRACK') {
			lastInfo.speed = markerInfo.speed / 10
			lastInfo.area = markerInfo.area
			lastInfo.range = (markerInfo.range / 1000 / 16).toFixed(2)
		}

		const pt = [markerInfo.latitude, markerInfo.longitude]
		if (!marker) {
			marker = L.circleMarker(pt, { radius:6, color:'#ffffff', weight:1, fillColor: '#2e2efa', fillOpacity: 0.5 })
			marker.addTo(layer)
		}
		let popup = `<h3>${markerInfo.trackNumber}</h3>`
		marker.setLatLng(pt);

		if (markerInfo.deleted || markerInfo.type === 'RADAR_TRACK_END') {
			marker.setStyle({
				fillColor:'#acacac'
			})
		} else {
			marker.setStyle({
				fillColor:'#2e2efa'
			})
		}
		
		popup += `speed: ${lastInfo.speed} knots<br />area: ${lastInfo.area}<br />range: ${lastInfo.range} km`
		marker.bindTooltip(popup);
		
		if (!line && Array.isArray(info)) {
			const pts = info.map(hit => [hit.latitude, hit.longitude])
			line = L.polyline(pts, { color: '#1717c7', opacity: 0.7 }).addTo(layer)
		} else if (line) {
			line.addLatLng(pt)
		}
	}
</script>

<style>
	.crap {
		color:#acacac;
	}
</style>